import { useState, useEffect } from "react";
import {
  fetchCareList,
  fetchCareDetail,
  createCare,
  updateCare,
  deleteCare,
  fetchCareHospitalList, 
  createCareHospital, 
  updateCareHospital, 
  deleteCareHospital,
  updateCareHospitalSortOrder
} from "../api/careApi";
import { searchCarer } from '../api/memberApi';
import Toast from "../components/Toast";
import { getCodeList } from "../api/codeApi";

const DeleteModal = ({ onClose, onConfirm }) => (
  <div style={ms.overlay}>
    <div style={{ ...ms.modal, maxWidth: 360, textAlign: "center", padding: "40px 24px" }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
      <h3 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" }}>간병정보를 삭제하시겠습니까?</h3>
      <p style={{ fontSize: 13, color: "#999", margin: "0 0 24px" }}>삭제된 데이터는 복구할 수 없습니다.</p>
      <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
        <button style={ms.cancelBtn} onClick={onClose}>취소</button>
        <button style={{ ...ms.saveBtn, background: "#ff4d4f" }} onClick={onConfirm}>삭제</button>
      </div>
    </div>
  </div>
);

const SectionTitle = ({ title }) => (
  <div style={{ fontSize: 13, fontWeight: 700, color: "#1677ff", borderLeft: "3px solid #1677ff", paddingLeft: 10, margin: "24px 0 12px" }}>
    {title}
  </div>
);

// ===================== 상세/등록 페이지 =====================
const DetailPage = ({ item, onBack, onSave, onDelete, isNew, isAdmin }) => {

const [showInsuModal, setShowInsuModal] = useState(false);
const insuList = getCodeList('INSU_LIST'); // 동기 조회, localStorage 캐시

const [hospitalList, setHospitalList] = useState([]);
const [showHospitalModal, setShowHospitalModal] = useState(false);
const [newHospitalName, setNewHospitalName] = useState("");
const [editingHospital, setEditingHospital] = useState(null); // 수정 중인 병원명
const [editHospitalValue, setEditHospitalValue] = useState("");

const loadHospitalList = async () => {
  const res = await fetchCareHospitalList();
  if (res.success) {
    setHospitalList(res.data);
    if (isNew && res.data.length > 0) {
      setForm(p => ({ ...p, hospital_name: p.hospital_name || res.data[0].hospital_name }));
    }
  }
};

useEffect(() => { loadHospitalList(); }, []);

  const emptyForm = {
    hospital_name: "",
    ward: "", room: "", patient_name: "", insu_name: "",
    carer1_name: "", carer1_birth: "", carer1_phone: "",
    carer2_name: "", carer2_birth: "", carer2_phone: "",
    carer3_name: "", carer3_birth: "", carer3_phone: "",
    care_start_dt: "", care_end_dt: "",
    care_time1_dt: 0, care_time1_amt: 0,
    care_time2_dt: 0, care_time2_amt: 0,
    care_time3_dt: 0, care_time3_amt: 0, care_time3_hour: "",
    logs: [],
  };

  const [form,       setForm]       = useState(item ? { ...item, logs: item.logs || [] } : emptyForm);
  const [showDelete, setShowDelete] = useState(false);
  const [toast,      setToast]      = useState("");  // ← DetailPage 전용 toast
  const [carerModal,   setCarerModal]   = useState(null);
  const [carerSearch,  setCarerSearch]  = useState('');
  const [carerResults, setCarerResults] = useState([]);
  const [carerLoading, setCarerLoading] = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  // ── 간병기간 (종료일 - 시작일 + 1, 시작/종료일 모두 포함) ──
  const calcCareDays = () => {
    if (!form.care_start_dt || !form.care_end_dt) return null;
    const s = new Date(form.care_start_dt), e = new Date(form.care_end_dt);
    if (isNaN(s) || isNaN(e)) return null;
    const diff = Math.round((e - s) / 86400000) + 1;
    return diff > 0 ? diff : null;
  };
  const careDays = calcCareDays();

  // ── 간병일지 행 조작 ──
  const LOG_TASKS = [
    { key: "task_meal",     label: "식사보조" },
    { key: "task_activity", label: "활동보조" },
    { key: "task_toilet",   label: "배변보조" },
    { key: "task_hygiene",  label: "위생보조" },
    { key: "task_etc",      label: "기타" },
  ];
  const addLogRow = () => setForm(p => ({
    ...p,
    logs: [...(p.logs || []), { log_dt: "", log_hours: "", task_meal: "Y", task_activity: "Y", task_toilet: "Y", task_hygiene: "Y", task_etc: "Y" }]
  }));
  const removeLogRow = (idx) => setForm(p => ({ ...p, logs: (p.logs || []).filter((_, i) => i !== idx) }));
  const setLogRow = (idx, k, v) => setForm(p => ({
    ...p, logs: (p.logs || []).map((r, i) => i === idx ? { ...r, [k]: v } : r)
  }));

  const parseBirthDate = (ssn1, ssn2) => {
    if (!ssn1 || ssn1.length !== 6) return '';
    const prefix = ssn2 ? String(ssn2)[0] : '0';
    const century = ['1','2'].includes(prefix) ? '19' : '20';
    return `${century}${ssn1}`;
  };

  const handleAddHospital = async () => {
    if (!newHospitalName.trim()) return;
    const res = await createCareHospital(newHospitalName.trim());
    if (res.success) { setNewHospitalName(""); loadHospitalList(); }
    else alert(res.message);
  };

  const handleUpdateHospital = async (oldName) => {
    if (!editHospitalValue.trim()) return;
    const res = await updateCareHospital(oldName, editHospitalValue.trim());
    if (res.success) { setEditingHospital(null); loadHospitalList(); }
    else alert(res.message);
  };

  const handleDeleteHospital = async (name) => {
    if (!window.confirm(`"${name}" 병원을 삭제하시겠습니까?`)) return;
    const res = await deleteCareHospital(name);
    if (res.success) loadHospitalList();
    else alert(res.message);
  };

  const handleMoveHospital = async (idx, direction) => {
    const targetIdx = idx + direction;
    if (targetIdx < 0 || targetIdx >= hospitalList.length) return;
    const a = hospitalList[idx];
    const b = hospitalList[targetIdx];
    await updateCareHospitalSortOrder(a.hospital_name, b.sort_order);
    await updateCareHospitalSortOrder(b.hospital_name, a.sort_order);
    loadHospitalList();
  };

  const handleCarerSearch = async () => {
    if (!carerSearch.trim()) return;
    setCarerLoading(true);
    try {
      const res = await searchCarer(carerSearch);
      if (res.success) setCarerResults(res.data);
      else showToast('❌ 검색 실패');
    } catch (err) {
      showToast('❌ 검색 실패');
    } finally {
      setCarerLoading(false);
    }
  };

  const handleCarerSelect = (carer) => {
    const birth = parseBirthDate(carer.ssn1, carer.ssn2);
    set(`carer${carerModal}_name`,  carer.name);
    set(`carer${carerModal}_birth`, birth);
    set(`carer${carerModal}_phone`, carer.phone || '');
    setCarerModal(null);
    setCarerSearch('');
    setCarerResults([]);
  };

  useEffect(() => {
    if (item) setForm({ ...item, logs: item.logs || [] });
  }, [item]);

  const inputStyle = (disabled) => ({
    border: "none", borderRadius: 0, padding: "12px 16px", fontSize: 14,
    fontFamily: "inherit",
    outline: "none", background: disabled ? "#f5f5f5" : "transparent",
    color: disabled ? "#aaa" : "#1a1a2e", width: "100%", boxSizing: "border-box"
  });

  const toKoreanAmount = (amount) => {
    const units = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
    const bigUnits = ['', '만', '억', '조'];
    if (!amount || amount === 0) return '영';
    let num = Number(amount);
    let result = '';
    let bigUnitIndex = 0;
    while (num > 0) {
      const chunk = num % 10000;
      if (chunk > 0) {
        let chunkStr = '';
        const thousands = Math.floor(chunk / 1000);
        const hundreds  = Math.floor((chunk % 1000) / 100);
        const tens      = Math.floor((chunk % 100) / 10);
        const ones      = chunk % 10;
        if (thousands > 0) chunkStr += (thousands > 1 ? units[thousands] : '') + '천';
        if (hundreds  > 0) chunkStr += (hundreds  > 1 ? units[hundreds]  : '') + '백';
        if (tens      > 0) chunkStr += (tens      > 1 ? units[tens]      : '') + '십';
        if (ones      > 0) chunkStr += units[ones];
        result = chunkStr + bigUnits[bigUnitIndex] + result;
      }
      num = Math.floor(num / 10000);
      bigUnitIndex++;
    }
    return result;
  };

  // 영수증 출력 로직
  const handlePrint = (mode = 'both') => {
    const today = new Date();
    const yyyy  = today.getFullYear();
    const mm    = String(today.getMonth() + 1).padStart(2, '0');
    const dd    = String(today.getDate()).padStart(2, '0');
    const totalAmt =
      (Number(form.care_time1_dt) || 0) * (Number(form.care_time1_amt) || 0) +
      (Number(form.care_time2_dt) || 0) * (Number(form.care_time2_amt) || 0) +
      (Number(form.care_time3_dt) || 0) * (Number(form.care_time3_amt) || 0);
    const carerNames = [form.carer1_name, form.carer2_name, form.carer3_name]
      .filter(n => n && n.trim() !== '').join(' / ');
    const timeRows = [1, 2, 3]
      .filter(n => form[`care_time${n}_dt`] > 0 || form[`care_time${n}_amt`] > 0)
      .map(n => {
        const dt = Number(form[`care_time${n}_dt`]) || 0;
        const amt = Number(form[`care_time${n}_amt`]) || 0;
        const hourLabel = n === 1 ? "12시간" : n === 2 ? "24시간" : (form.care_time3_hour ? `${form.care_time3_hour}시간` : "__시간");
        return `<p>${hourLabel} ${dt}일 x ${amt.toLocaleString()}원 = ${(dt * amt).toLocaleString()} 원</p>`;
      }).join('');
    const startDt = form.care_start_dt ? new Date(form.care_start_dt).toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' }) : '-';
    const endDt   = form.care_end_dt   ? new Date(form.care_end_dt).toLocaleDateString('ko-KR',   { year: 'numeric', month: 'long', day: 'numeric' }) : '-';

    const receiptHTML = (type) => `
      <div class="receipt">
        <div class="title">영 수 증</div>
        <div class="subtitle">( ${type} )</div>
        <div class="amount-row">
          <span class="amount-label">금</span>
          <span class="amount-korean">${toKoreanAmount(totalAmt)}원정</span>
          <span class="amount-number">￦ ${totalAmt.toLocaleString()} 원</span>
        </div>
        <table class="info-table">
          <tr><td class="label">병 원 명</td><td>${form.hospital_name || '-'} ${form.ward ? form.ward + '병동' : ''} ${form.room ? form.room + '호' : ''}</td></tr>
          <tr><td class="label">환 자 명</td><td>${form.patient_name || '-'}</td></tr>
          <tr><td class="label">간병사명</td><td>${carerNames || '-'}</td></tr>
          <tr><td class="label">간병시간</td><td><p>${startDt} ~ ${endDt}</p>${timeRows}</td></tr>
        </table>
        <div class="footer-text">위 금액을 간병비로 정히 영수합니다.<br/>${yyyy}년 ${mm}월 ${dd}일</div>
        <div class="sign-row"><span>간병사 ${form.carer1_name || ''} (서명)</span></div>
        <div class="company">(사)보건복지자원연구원 무료소개소 희망간병 사업자등록번호 101-82-16704</div>
      </div>
    `;

    const body = mode === 'evidence'
      ? receiptHTML('증 빙 용')
      : `${receiptHTML('보 관 용')}${receiptHTML('증 빙 용')}`;

    const printHtml = `<!DOCTYPE html><html lang="ko"><head><meta charset="utf-8"/><title>영수증</title><style>
      *{margin:0;padding:0;box-sizing:border-box;}
      body{font-family:'맑은 고딕','Malgun Gothic',sans-serif;font-size:16px;color:#000;}
      .receipt{width:100%;padding:60px 80px;page-break-after:always;}
      .receipt:last-child{page-break-after:avoid;}
      .title{text-align:center;font-size:26px;font-weight:bold;letter-spacing:12px;margin-bottom:4px;}
      .subtitle{text-align:center;font-size:16px;margin-bottom:24px;letter-spacing:4px;}
      .amount-row{display:flex;align-items:baseline;gap:12px;border-top:1.5px solid #000;border-bottom:1.5px solid #000;padding:10px 0;margin-bottom:16px;}
      .amount-label{font-size:16px;font-weight:bold;min-width:20px;}
      .amount-korean{font-size:16px;font-weight:bold;flex:1;}
      .amount-number{font-size:16px;font-weight:bold;}
      .info-table{width:100%;border-collapse:collapse;margin-bottom:20px;}
      .info-table td{padding:8px 10px;font-size:16px;vertical-align:top;line-height:1.8;}
      .info-table .label{min-width:80px;font-weight:bold;white-space:nowrap;}
      .footer-text{text-align:center;font-size:16px;margin:16px 0 10px;line-height:2.0;}
      .sign-row{text-align:center;font-size:16px;margin-bottom:16px;}
      .company{text-align:center;font-size:16px;color:#444;border-top:1px solid #aaa;padding-top:10px;}
      @media print{@page{size:A4 portrait;margin:0;}}
    </style></head><body>${body}</body></html>`;

    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(iframe);
    iframe.contentDocument.open();
    iframe.contentDocument.write(printHtml);
    iframe.contentDocument.close();
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => document.body.removeChild(iframe), 1000);
    }, 500);
  };

  // 간병사실확인증 출력 로직
  const handlePrintConfirm = (mode = 'both') => {
    const today = new Date();
    const yyyy  = today.getFullYear();
    const mm    = String(today.getMonth() + 1).padStart(2, '0');
    const dd    = String(today.getDate()).padStart(2, '0');
    const startDt = form.care_start_dt ? new Date(form.care_start_dt).toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' }) : '-';
    const endDt   = form.care_end_dt   ? new Date(form.care_end_dt).toLocaleDateString('ko-KR',   { year: 'numeric', month: 'long', day: 'numeric' }) : '-';
    const fmtBirth = (v) => {
      const d = String(v || '').replace(/\D/g, '');
      return d.length === 8 ? `${d.slice(0, 4)}/${d.slice(4, 6)}/${d.slice(6)}` : (v || '');
    };
    const carerRows = [1, 2, 3]
      .filter(n => form[`carer${n}_name`] && form[`carer${n}_name`].trim() !== '')
      .map(n => `<tr><td>${form[`carer${n}_name`]||''}</td><td>생년월일 : ${fmtBirth(form[`carer${n}_birth`])}</td><td>Tel) ${form[`carer${n}_phone`]||''}</td></tr>`).join('');
    const timeRows = [1, 2, 3]
      .filter(n => form[`care_time${n}_dt`] > 0 || form[`care_time${n}_amt`] > 0)
      .map(n => {
        const dt = Number(form[`care_time${n}_dt`]) || 0;
        const amt = Number(form[`care_time${n}_amt`]) || 0;
        const hourLabel = n === 1 ? "12시간" : n === 2 ? "24시간" : (form.care_time3_hour ? `${form.care_time3_hour}시간` : "__시간");
        return `<p>${hourLabel} ${dt}일 x ${amt.toLocaleString()}원 = ${(dt * amt).toLocaleString()} 원</p>`;
      }).join('');

    // 직인 이미지
    const user    = JSON.parse(localStorage.getItem('user') || '{}');
    const sealImg = user.seal_img || '';
    const sealHtml = sealImg
      ? `<img src="${sealImg}" style="width:70px;height:70px;object-fit:contain;position:absolute;top:-10px;left:480px;opacity:0.85;" />`
      : '(직인)';

    const confirmHTML = (type) => `
      <div class="receipt">
        <div class="title">간 병 사 실 확 인 증</div>
        <div class="subtitle">( ${type} )</div>
        <table class="info-table">
          <tr><td class="label">병 원 명</td><td>${form.hospital_name||'-'} ${form.ward?form.ward+'병동':''} ${form.room?form.room+'호':''}</td></tr>
          <tr><td class="label">환 자 명</td><td>
            <table class="patient-table"><tr>
              <td class="name">${form.patient_name||'-'}</td>
              <td class="label" style="width:70px;">보 험 사</td>
              <td>${form.insu_name||'-'}</td>
            </tr></table>
          </td></tr>
          <tr><td class="label">간 병 사 명</td><td><table class="carer-table">${carerRows}</table></td></tr>
          <tr><td class="label">간 병 시 간</td><td><p>${startDt} ~ ${endDt}</p>${timeRows}</td></tr>
        </table>
        <div class="footer-text">위 사람이 희망간병 소개로<br/>위와 같이 간병하였음을 증명합니다.<br/>${yyyy}년 ${mm}월 ${dd}일</div>
        <div class="company" style="position:relative;">
          (사)보건복지자원연구원 무료소개소 희망간병 [직인]${sealHtml}<br/>
          사업자등록번호 101-82-16704 / TEL 02-3672-3400
        </div>
      </div>
    `;

    const body = mode === 'evidence'
      ? confirmHTML('증 빙 용')
      : `${confirmHTML('보 관 용')}${confirmHTML('증 빙 용')}`;

    const printHtml = `<!DOCTYPE html><html lang="ko"><head><meta charset="utf-8"/><title>간병사실확인증</title><style>
      *{margin:0;padding:0;box-sizing:border-box;}
      body{font-family:'맑은 고딕','Malgun Gothic',sans-serif;font-size:16px;color:#000;}
      .receipt{width:100%;padding:60px 80px;page-break-after:always;}
      .receipt:last-child{page-break-after:avoid;}
      .title{text-align:center;font-size:22px;font-weight:bold;letter-spacing:10px;margin-bottom:4px;}
      .subtitle{text-align:center;font-size:16px;margin-bottom:24px;letter-spacing:4px;}
      .info-table{width:100%;border-collapse:collapse;margin-bottom:20px;}
      .info-table td{padding:8px 10px;font-size:16px;vertical-align:top;line-height:1.8;}
      .info-table .label{min-width:90px;font-weight:bold;white-space:nowrap;}
      .carer-table{width:100%;border-collapse:collapse;}
      .carer-table td{padding:2px 8px 2px 0;font-size:16px;min-width:80px;}
      .patient-table{width:100%;border-collapse:collapse;}
      .patient-table td{padding:0;font-size:16px;vertical-align:middle;}
      .patient-table td.name{width:220px;}
      .patient-table td.label{font-weight:bold;white-space:nowrap;padding-right:6px;}
      .footer-text{font-size:16px;margin:20px 0 14px;line-height:2.0;text-align:center;}
      .company{text-align:center;font-size:16px;color:#444;border-top:1px solid #aaa;padding-top:10px;line-height:1.8;}
      @media print{@page{size:A4 portrait;margin:0;}}
    </style></head><body>${body}</body></html>`;

    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(iframe);
    iframe.contentDocument.open();
    iframe.contentDocument.write(printHtml);
    iframe.contentDocument.close();
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => document.body.removeChild(iframe), 1000);
    }, 500);
  };

  // 희망 간병 일지 출력 로직
  const handlePrintLog = () => {
    // 간병일자 표시: 입력창과 동일한 yyyy-mm-dd 형식
    const periodTxt = (form.care_start_dt && form.care_end_dt)
      ? `${form.care_start_dt} ~ ${form.care_end_dt}` : '';
    const daysTxt = careDays ? `${careDays} 일간` : '';
    const mark = (v) => v === 'Y' ? '■' : '□';

    const MIN_ROWS = 20; // 빈 행 채움(양식 유지)
    const rows = [...(form.logs || [])];
    while (rows.length < MIN_ROWS) rows.push(null);
    const rowHtml = rows.map(r => `
      <tr>
        <td>${r ? (r.log_dt || '') : ''}</td>
        <td>${r ? (r.log_hours || '') : ''}</td>
        <td class="task">${r
          ? `식사보조 ${mark(r.task_meal)} / 활동보조 ${mark(r.task_activity)} / 배변보조 ${mark(r.task_toilet)} / 위생보조 ${mark(r.task_hygiene)} / 기타${mark(r.task_etc)}`
          : ''}</td>
      </tr>`).join('');

    // 하단 일자 (종료일 기준) / 직인
    let footDt = '';
    if (form.care_end_dt) {
      const [fy, fm, fd] = String(form.care_end_dt).split('-');
      footDt = `${String(fy).slice(2)}년 ${Number(fm)}월 ${Number(fd)}일`;
    }

    const body = `
      <div class="page">
        <div class="title-box">희 망 간 병 일 지</div>
        <table class="info">
          <colgroup><col style="width:14%"/><col style="width:26%"/><col style="width:17%"/><col style="width:43%"/></colgroup>
          <tr><th>환자명</th><td>${form.patient_name || ''}</td><th>생년월일</th><td></td></tr>
          <tr><th rowspan="2">간병일자</th><td rowspan="2">${periodTxt}</td><th>간병기간</th><td>${daysTxt}</td></tr>
          <th rowspan="2" style="white-space:nowrap;">환자와의 관계</th><td rowspan="2">간병사</td></tr>
          <tr><th>간병사 성명</th><td>${form.carer1_name || ''}</td></tr>
          <tr><th rowspan="2">간병사<br/>연락처</th><td rowspan="2">${form.carer1_phone || ''}</td><th>소속업체</th><td>(사) 보건복지자원연구원 무료소개소 희망간병</td></tr>
          <tr><th>사업자등록번호</th><td>101-82-16704</td></tr>
        </table>
        <table class="log">
          <thead><tr><th style="width:17%;">간병일자</th><th style="width:15%;">간병시간</th><th>간병 업무</th></tr></thead>
          <tbody>${rowHtml}</tbody>
        </table>
        <div class="foot">
          <div style="display:inline-block;text-align:left;">
            <div>간병일자 : ${footDt}</div>
            <div style="display:flex;justify-content:space-between;"><span>작성자 :</span><span>(인)</span></div>
          </div>
        </div>
      </div>`;

    const printHtml = `<!DOCTYPE html><html lang="ko"><head><meta charset="utf-8"/><title>희망 간병 일지</title><style>
      *{margin:0;padding:0;box-sizing:border-box;}
      body{font-family:'맑은 고딕','Malgun Gothic',sans-serif;font-size:13px;color:#000;}
      .page{width:100%;padding:36px 44px;}
      .title-box{border:1.5px solid #000;text-align:center;font-size:22px;font-weight:bold;letter-spacing:6px;padding:10px 0;margin-bottom:14px;}
      table{width:100%;border-collapse:collapse;}
      table.info{margin-bottom:22px;border:1.5px solid #000;}
      table.info th,table.info td{border:1px solid #000;padding:7px 8px;font-size:13px;text-align:center;height:30px;}
      table.info th{font-weight:normal;white-space:nowrap;}
      table.log{border:1.5px solid #000;}
      table.log th,table.log td{border:1px solid #000;padding:4px 6px;font-size:13px;text-align:center;height:32px;}
      table.log th{font-weight:normal;}
      table.log td.task{text-align:center;}
      .foot{text-align:right;font-weight:bold;font-size:17px;line-height:2.1;margin-top:26px;}
      @media print{@page{size:A4 portrait;margin:0;}}
    </style></head><body>${body}</body></html>`;

    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(iframe);
    iframe.contentDocument.open();
    iframe.contentDocument.write(printHtml);
    iframe.contentDocument.close();
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => document.body.removeChild(iframe), 1000);
    }, 500);
  };

  return (
    <div style={styles.wrap}>
      <Toast msg={toast} />
      <button style={styles.backBtn} onClick={onBack}>← 목록으로</button>
      <div style={styles.pageHeader}>
        <h1 style={styles.pageTitle}>{isNew ? "🏥 간병정보 등록" : "🏥 간병정보 상세"}</h1>
        {!isNew && <span style={styles.seqBadge}>연번 {item?.seq_no}</span>}
      </div>

      <div style={{ ...styles.card, padding: 32 }}>

        {/* 기본정보 */}
        <SectionTitle title="기본 정보" />
        <div style={detailStyles.grid}>
          <div style={detailStyles.field}>
            <label style={{ ...detailStyles.label, display: "flex", alignItems: "center", gap: 4 }}>
              병원명
              <button type="button"
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "#888", padding: 0 }}
                onClick={() => setShowHospitalModal(true)}
                title="병원 관리">⚙️</button>
            </label>
            <select style={inputStyle(false)} value={form.hospital_name || ""}
              onChange={e => set("hospital_name", e.target.value)}>
              {hospitalList.length === 0 && <option value="">등록된 병원이 없습니다</option>}
              {hospitalList.map(h => (
                <option key={h.hospital_name} value={h.hospital_name}>{h.hospital_name}</option>
              ))}
            </select>
          </div>
          {[
            { label: "환자명",        key: "patient_name",  placeholder: "환자명 입력" },
            { label: "병동",          key: "ward",          placeholder: "병동 입력" },
            { label: "병실",          key: "room",          placeholder: "병실 입력" },
            { label: "간병 시작일자", key: "care_start_dt", type: "date" },
            { label: "간병 종료일자", key: "care_end_dt",   type: "date" },
          ].map(f => (
            <div key={f.key} style={detailStyles.field}>
              <label style={detailStyles.label}>{f.label}</label>
              <input style={inputStyle(false)} type={f.type || "text"}
                value={form[f.key] || ""} onChange={e => set(f.key, e.target.value)}
                placeholder={f.placeholder || ""} />
            </div>
          ))}

          {/* 간병기간 - 계산값 (종료일 - 시작일 + 1) */}
          <div style={detailStyles.field}>
            <label style={detailStyles.label}>간병기간</label>
            <input style={inputStyle(true)} disabled value={careDays ? `${careDays} 일간` : "-"} />
          </div>

          {/* 보험사명 - 전용 필드 (돋보기 검색) */}
          <div style={detailStyles.field}>
            <label style={{ ...detailStyles.label, display: "flex", alignItems: "center", gap: 4 }}>
              보험사명
              <button type="button"
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: "#1677ff", padding: 0 }}
                onClick={() => setShowInsuModal(true)}
                title="보험사 검색">🔍</button>
            </label>
            <input style={inputStyle(false)} value={form.insu_name || ""}
              onChange={e => set("insu_name", e.target.value)} placeholder="보험사명 입력" />
          </div>
        </div>

        {/* 간병사 정보 */}
        {[1, 2, 3].map(n => (
          <div key={n}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <SectionTitle title={`간병사 ${n}`} />
              <button
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, padding: "0 4px", color: "#1677ff", marginLeft: 8 }}
                onClick={() => { setCarerModal(n); setCarerSearch(''); setCarerResults([]); }}
                title="조합원 검색"
              >🔍</button>
            </div>
            <div style={{ display: "flex", gap: 0, background: "#fafafa", borderRadius: 8, border: "1.5px solid #e0e0e0", overflow: "hidden" }}>
              <div style={{ display: "flex", alignItems: "center", flex: 1, borderRight: "1.5px solid #e0e0e0" }}>
                <label style={detailStyles.label}>성명</label>
                <input style={inputStyle(false)} value={form[`carer${n}_name`] || ""}
                  onChange={e => set(`carer${n}_name`, e.target.value)} placeholder={`간병사${n} 성명`} />
              </div>
              <div style={{ display: "flex", alignItems: "center", flex: 1, borderRight: "1.5px solid #e0e0e0" }}>
                <label style={detailStyles.label}>생년월일</label>
                <input style={inputStyle(false)} value={form[`carer${n}_birth`] || ""}
                  onChange={e => set(`carer${n}_birth`, e.target.value)} placeholder="YYYYMMDD" maxLength={8} />
              </div>
              <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
                <label style={detailStyles.label}>전화번호</label>
                <input style={inputStyle(false)} value={form[`carer${n}_phone`] || ""}
                  onChange={e => set(`carer${n}_phone`, e.target.value)} placeholder="010-0000-0000" />
              </div>
            </div>
          </div>
        ))}

        {/* 간병 시간 및 금액 */}
        <SectionTitle title="간병 시간 및 금액" />
        {[1, 2, 3].map(n => {
          const hourLabel = n === 1 ? "12시간" : n === 2 ? "24시간" : (form.care_time3_hour ? `${form.care_time3_hour}시간` : "__시간");
          return (
            <div key={n} style={{ marginBottom: 10 }}>
              {n === 3 && (
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                  <span style={{ fontSize: 13, color: "#888" }}>시간 구분 입력</span>
                  <input
                    style={{ border: "1.5px solid #e0e0e0", borderRadius: 6, padding: "6px 10px", fontSize: 13, width: 16 }}
                    value={form.care_time3_hour || ""}
                    onChange={e => set("care_time3_hour", e.target.value)}
                  />
                  <span style={{ fontSize: 13, color: "#888" }}>시간</span>
                </div>
              )}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                <div style={detailStyles.field}>
                  <label style={detailStyles.label}>{hourLabel} 일자</label>
                  <input style={inputStyle(false)} type="number"
                    value={form[`care_time${n}_dt`] || 0}
                    onChange={e => set(`care_time${n}_dt`, e.target.value)} />
                </div>
                <div style={detailStyles.field}>
                  <label style={detailStyles.label}>{hourLabel} 금액</label>
                  <input style={inputStyle(false)} type="number" step={10000}
                    value={form[`care_time${n}_amt`] || 0}
                    onChange={e => set(`care_time${n}_amt`, e.target.value)} />
                </div>
                <div style={detailStyles.field}>
                  <label style={detailStyles.label}>{hourLabel} 최종금액</label>
                  <input style={inputStyle(true)} type="text" disabled
                    value={((Number(form[`care_time${n}_dt`])||0)*(Number(form[`care_time${n}_amt`])||0)).toLocaleString()+' 원'} />
                </div>
              </div>
            </div>
          );
        })}

        {/* 간병일지항목(필요시 입력) */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "24px 0 12px" }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#1677ff", borderLeft: "3px solid #1677ff", paddingLeft: 10 }}>
            간병일지항목(필요시 입력)
          </div>
          <button type="button"
            style={{ background: "#fff", border: "1px solid #1677ff", color: "#1677ff", borderRadius: 6, padding: "4px 8px", fontSize: 12, cursor: "pointer", whiteSpace: "nowrap" }}
            onClick={addLogRow}>＋ 행 추가</button>
        </div>
        <div style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, overflow: "hidden", background: "#fafafa" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 3fr 90px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" }}>
            {["간병일자", "간병시간", "간병업무", "삭제"].map(h => (
              <div key={h} style={{ padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#888" }}>{h}</div>
            ))}
          </div>
          {(form.logs || []).length === 0 && (
            <div style={{ textAlign: "center", padding: "18px 0", color: "#bbb", fontSize: 13 }}>
              등록된 간병일지가 없습니다. 필요시 [행 추가]로 입력하세요.
            </div>
          )}
          {(form.logs || []).map((row, idx) => (
            <div key={idx} style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 3fr 90px", alignItems: "center", borderBottom: "1px solid #f0f0f0" }}>
              <input style={inputStyle(false)} value={row.log_dt || ""} placeholder="예) 26,9,9~"
                onChange={e => setLogRow(idx, "log_dt", e.target.value)} />
              <input style={inputStyle(false)} value={row.log_hours || ""} placeholder="예) 24시간"
                onChange={e => setLogRow(idx, "log_hours", e.target.value)} />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 14, padding: "0 12px" }}>
                {LOG_TASKS.map(t => (
                  <label key={t.key} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13, color: "#333", cursor: "pointer" }}>
                    <input type="checkbox" checked={row[t.key] === "Y"}
                      onChange={e => setLogRow(idx, t.key, e.target.checked ? "Y" : "N")} />
                    {t.label}
                  </label>
                ))}
              </div>
              <div style={{ padding: "0 8px" }}>
                <button type="button"
                  style={{ background: "#fff", border: "1px solid #ff4d4f", color: "#ff4d4f", borderRadius: 6, padding: "4px 8px", fontSize: 12, cursor: "pointer", whiteSpace: "nowrap" }}
                  onClick={() => removeLogRow(idx)}>행 삭제</button>
              </div>
            </div>
          ))}
        </div>

        {/* 등록/수정 정보 */}
        {!isNew && (
          <>
            <SectionTitle title="등록/수정 정보" />
            <div style={detailStyles.grid}>
              {[
                { label: "최초등록자",   key: "reg_emp_no" },
                { label: "최초등록일시", key: "reg_dt" },
                { label: "최종수정자",   key: "mod_emp_no" },
                { label: "최종수정일시", key: "mod_dt" },
              ].map(f => (
                <div key={f.key} style={detailStyles.field}>
                  <label style={detailStyles.label}>{f.label}</label>
                  <input style={inputStyle(true)} value={form[f.key] || "-"} disabled />
                </div>
              ))}
            </div>
          </>
        )}

        {/* 버튼 */}
        {isAdmin && (
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 32, paddingTop: 20, borderTop: "1px solid #f0f0f0" }}>
            {!isNew && <button style={{ ...styles.printBtn, borderColor: "#52c41a", color: "#52c41a", outline: "none", whiteSpace: "nowrap" }} onClick={() => handlePrint('evidence')}>🖨️ 영수증(증빙용)</button>}
            {!isNew && <button style={{ ...styles.printBtn, borderColor: "#52c41a", color: "#52c41a", outline: "none", whiteSpace: "nowrap" }} onClick={() => handlePrint('both')}>🖨️ 영수증(통합)</button>}
            {!isNew && <button style={{ ...styles.printBtn, borderColor: "#fa8c16", color: "#fa8c16", whiteSpace: "nowrap" }} onClick={() => handlePrintConfirm('evidence')}>📋 확인증(증빙용)</button>}
            {!isNew && <button style={{ ...styles.printBtn, borderColor: "#fa8c16", color: "#fa8c16", whiteSpace: "nowrap" }} onClick={() => handlePrintConfirm('both')}>📋 확인증(통합)</button>}
            {!isNew && <button style={{ ...styles.printBtn, borderColor: "#52c41a", color: "#52c41a", whiteSpace: "nowrap" }} onClick={handlePrintLog}>📝 간병일지</button>}
            <button style={{ ...styles.editBtn, whiteSpace: "nowrap" }} onClick={() => onSave(form)}>
              {isNew ? "✅ 등록" : "✏️ 수정"}
            </button>
            {!isNew && <button style={{ ...styles.deleteBtn, whiteSpace: "nowrap" }} onClick={() => setShowDelete(true)}>🗑 삭제</button>}
          </div>
        )}
      </div>

      {/* 간병사 검색 모달 */}
      {carerModal && (
        <div style={ms.overlay}>
          <div style={{ ...ms.modal, maxWidth: 480, padding: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f0f0f0" }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e", margin: 0 }}>🔍 간병사 {carerModal} 조합원 검색</h3>
              <button style={{ background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" }}
                onClick={() => setCarerModal(null)}>✕</button>
            </div>
            <div style={{ padding: "16px 24px", borderBottom: "1px solid #f0f0f0", display: "flex", gap: 8 }}>
              <input
                style={{ flex: 1, border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "10px 14px", fontSize: 14, outline: "none" }}
                placeholder="이름 입력"
                value={carerSearch}
                onChange={e => setCarerSearch(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleCarerSearch()}
                autoFocus
              />
              <button
                style={{ background: "#1677ff", color: "#fff", border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
                onClick={handleCarerSearch}
              >{carerLoading ? '검색 중...' : '검색'}</button>
            </div>
            <div style={{ maxHeight: 320, overflowY: "auto" }}>
              {carerResults.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "#bbb", fontSize: 14 }}>
                  {carerSearch ? '검색 결과가 없습니다.' : '이름을 입력하고 검색하세요.'}
                </div>
              ) : (
                <>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1.5fr", padding: "10px 24px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" }}>
                    {["성명", "생년월일", "전화번호"].map(h => (
                      <div key={h} style={{ fontSize: 12, fontWeight: 700, color: "#888" }}>{h}</div>
                    ))}
                  </div>
                  {carerResults.map((c, i) => (
                    <div key={i}
                      style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1.5fr", padding: "14px 24px", borderBottom: "1px solid #f5f5f5", cursor: "pointer", transition: "background 0.15s" }}
                      onClick={() => handleCarerSelect(c)}
                      onMouseEnter={e => e.currentTarget.style.background = "#f0f7ff"}
                      onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                      <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1a2e" }}>{c.name}</div>
                      <div style={{ fontSize: 13, color: "#666" }}>{parseBirthDate(c.ssn1, c.ssn2) || '-'}</div>
                      <div style={{ fontSize: 13, color: "#666" }}>{c.phone || '-'}</div>
                    </div>
                  ))}
                </>
              )}
            </div>
            <div style={{ padding: "14px 24px", borderTop: "1px solid #f0f0f0", textAlign: "right" }}>
              <button style={ms.cancelBtn} onClick={() => setCarerModal(null)}>닫기</button>
            </div>
          </div>
        </div>
      )}

      {showDelete && (
        <DeleteModal onClose={() => setShowDelete(false)} onConfirm={() => onDelete(form.seq_no)} />
      )}

      {showInsuModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 0, width: 380, maxHeight: "70vh", display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f0f0f0" }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e", margin: 0 }}>🔍 보험사 검색</h3>
              <button style={{ background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" }}
                onClick={() => setShowInsuModal(false)}>✕</button>
            </div>
            <div style={{ overflowY: "auto", flex: 1 }}>
              {insuList.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "#bbb", fontSize: 14 }}>
                  등록된 보험사가 없습니다.
                </div>
              ) : (
                insuList.map(c => (
                  <div key={c.code}
                    style={{ padding: "12px 24px", borderBottom: "1px solid #f5f5f5", cursor: "pointer", fontSize: 14, color: "#1a1a2e" }}
                    onClick={() => { set("insu_name", c.code_nm); setShowInsuModal(false); }}
                    onMouseEnter={e => e.currentTarget.style.background = "#f0f7ff"}
                    onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                    {c.code_nm}
                  </div>
                ))
              )}
            </div>
            <div style={{ padding: "14px 24px", borderTop: "1px solid #f0f0f0", textAlign: "right" }}>
              <span style={{ fontSize: 12, color: "#bbb", marginRight: 12 }}>클릭하면 보험사명이 자동 입력돼요</span>
              <button style={{ border: "1px solid #e0e0e0", background: "#fff", borderRadius: 8, padding: "6px 16px", fontSize: 13, cursor: "pointer" }}
                onClick={() => setShowInsuModal(false)}>닫기</button>
            </div>
          </div>
        </div>
      )}

      {showHospitalModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 0, width: 380, maxHeight: "70vh", display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f0f0f0" }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e", margin: 0 }}>⚙️ 병원 관리</h3>
              <button style={{ background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" }}
                onClick={() => setShowHospitalModal(false)}>✕</button>
            </div>

            {/* 등록 */}
            <div style={{ display: "flex", gap: 8, padding: "16px 24px", borderBottom: "1px solid #f0f0f0" }}>
              <input
                style={{ flex: 1, border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", fontSize: 13, outline: "none" }}
                placeholder="새 병원명 입력"
                value={newHospitalName}
                onChange={e => setNewHospitalName(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleAddHospital()}
              />
              <button style={{ background: "#1677ff", color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
                onClick={handleAddHospital}>추가</button>
            </div>

            {/* 목록 */}
            <div style={{ overflowY: "auto", flex: 1 }}>
              {hospitalList.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "#bbb", fontSize: 14 }}>등록된 병원이 없습니다.</div>
              ) : (
                hospitalList.map((h, idx) => (
                  <div key={h.hospital_name} style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 24px", borderBottom: "1px solid #f5f5f5" }}>
                    {editingHospital === h.hospital_name ? (
                      <>
                        <input
                          style={{ flex: 1, border: "1.5px solid #1677ff", borderRadius: 6, padding: "6px 10px", fontSize: 13, outline: "none" }}
                          value={editHospitalValue}
                          onChange={e => setEditHospitalValue(e.target.value)}
                          autoFocus
                        />
                        <button style={{ background: "none", border: "none", color: "#1677ff", fontSize: 12, cursor: "pointer" }}
                          onClick={() => handleUpdateHospital(h.hospital_name)}>저장</button>
                        <button style={{ background: "none", border: "none", color: "#aaa", fontSize: 12, cursor: "pointer" }}
                          onClick={() => setEditingHospital(null)}>취소</button>
                      </>
                    ) : (
                      <>
                        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                          <button style={{ background: "none", border: "none", cursor: idx === 0 ? "default" : "pointer", color: idx === 0 ? "#ddd" : "#888", fontSize: 11 }}
                            onClick={() => handleMoveHospital(idx, -1)} disabled={idx === 0}>▲</button>
                          <button style={{ background: "none", border: "none", cursor: idx === hospitalList.length - 1 ? "default" : "pointer", color: idx === hospitalList.length - 1 ? "#ddd" : "#888", fontSize: 11 }}
                            onClick={() => handleMoveHospital(idx, 1)} disabled={idx === hospitalList.length - 1}>▼</button>
                        </div>
                        <span style={{ flex: 1, fontSize: 14, color: "#1a1a2e" }}>{h.hospital_name}</span>
                        <button style={{ background: "none", border: "none", color: "#1677ff", fontSize: 12, cursor: "pointer" }}
                          onClick={() => { setEditingHospital(h.hospital_name); setEditHospitalValue(h.hospital_name); }}>수정</button>
                        <button style={{ background: "none", border: "none", color: "#ff4d4f", fontSize: 12, cursor: "pointer" }}
                          onClick={() => handleDeleteHospital(h.hospital_name)}>삭제</button>
                      </>
                    )}
                  </div>
                ))
              )}
            </div>

            <div style={{ padding: "14px 24px", borderTop: "1px solid #f0f0f0", textAlign: "right" }}>
              <button style={{ border: "1px solid #e0e0e0", background: "#fff", borderRadius: 8, padding: "6px 16px", fontSize: 13, cursor: "pointer" }}
                onClick={() => setShowHospitalModal(false)}>닫기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ===================== 리스트 페이지 =====================
export default function CarePage({ onLogout, userLevel }) {
  const isAdmin = ['0', '1', '3'].includes(userLevel); // 희망 관리자 포함
  const [page,          setPage]          = useState("list");
  const [list,          setList]          = useState([]);
  const [selected,      setSelected]      = useState(null);
  const [isNew,         setIsNew]         = useState(false);
  const [loading,       setLoading]       = useState(false);
  const [toast,         setToast]         = useState("");
  const [searchPatient, setSearchPatient] = useState("");
  const [searchCarer,   setSearchCarer]   = useState("");
  const [searchCarer2,  setSearchCarer2]  = useState("");
  const [searchCarer3,  setSearchCarer3]  = useState("");
  const [searchDt,      setSearchDt]      = useState("");
  const [currentPage,   setCurrentPage]   = useState(1);
  const PAGE_SIZE = 10;

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  const loadList = async () => {
    setLoading(true);
    try {
      const res = await fetchCareList(searchPatient, searchCarer, searchCarer2, searchCarer3, searchDt);
      if (res.success) setList(res.data);
      else if (res.message === '토큰이 만료되었습니다. 다시 로그인해주세요.') onLogout();
    } catch (err) {
      showToast("❌ 목록 조회 실패");
    } finally {
      setLoading(false);
    }
  };

  const loadDetail = async (seq_no) => {
    try {
      const res = await fetchCareDetail(seq_no);
      if (res.success) { setSelected(res.data); setIsNew(false); setPage("detail"); }
      else showToast(`❌ ${res.message}`);
    } catch (err) {
      showToast("❌ 상세 조회 실패");
    }
  };

  useEffect(() => { loadList(); }, []);

  const paginated  = list.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);
  const totalPages = Math.ceil(list.length / PAGE_SIZE);

  const handleSearch = () => { setCurrentPage(1); loadList(); };

  const handleReset = () => {
    setSearchPatient(""); setSearchCarer(""); setSearchCarer2(""); setSearchCarer3(""); setSearchDt("");
    setCurrentPage(1);
    fetchCareList("", "", "", "", "").then(res => { if (res.success) setList(res.data); });
  };

const handleSave = async (form) => {
  try {
    const res = isNew ? await createCare(form) : await updateCare(form.seq_no, form);
    if (res.success) {
      await loadList();
      const targetSeqNo = isNew ? res.seq_no : form.seq_no;
      const detailRes = await fetchCareDetail(targetSeqNo);
      if (detailRes.success) {
        setSelected(detailRes.data);
        setIsNew(false);
      }
      showToast(isNew ? "✅ 간병정보가 등록되었습니다." : "✅ 간병정보가 수정되었습니다.");
    } else showToast(`❌ ${res.message}`);
  } catch (err) { showToast("❌ 저장 실패"); }
};

  const handleDelete = async (seq_no) => {
    try {
      const res = await deleteCare(seq_no);
      if (res.success) { await loadList(); setPage("list"); showToast("✅ 간병정보가 삭제되었습니다."); }
      else showToast(`❌ ${res.message}`);
    } catch (err) { showToast("❌ 삭제 실패"); }
  };

  if (page === "detail") {
    return (
      <>
        <Toast msg={toast} />
        <DetailPage
          item={selected}
          onBack={() => setPage("list")}
          onSave={handleSave}
          onDelete={handleDelete}
          isNew={isNew}
          isAdmin={isAdmin}
        />
      </>
    );
  }

  return (
    <div style={styles.wrap}>
      <Toast msg={toast} />

      <div style={styles.pageHeader}>
        <div><h1 style={styles.pageTitle}>🏥 간병정보 관리</h1></div>
        <div style={styles.statBadge}>총 {list.length}건</div>
      </div>

      {/* 검색 */}
      <div style={{ ...styles.filterCard, gap: 6 }}>
        <input style={{ ...styles.searchInput, flex: "1 1 80px", minWidth: 60 }} placeholder="🔍 환자명"
          value={searchPatient} onChange={e => setSearchPatient(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSearch()} />
        <input style={{ ...styles.searchInput, flex: "1 1 80px", minWidth: 60 }} placeholder="🔍 간병사1"
          value={searchCarer} onChange={e => setSearchCarer(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSearch()} />
        <input style={{ ...styles.searchInput, flex: "1 1 80px", minWidth: 60 }} placeholder="🔍 간병사2"
          value={searchCarer2} onChange={e => setSearchCarer2(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSearch()} />
        <input style={{ ...styles.searchInput, flex: "1 1 80px", minWidth: 60 }} placeholder="🔍 간병사3"
          value={searchCarer3} onChange={e => setSearchCarer3(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSearch()} />
        <span style={{ fontSize: 12, color: "#888", whiteSpace: "nowrap" }}>조회일자</span>
        <input type="date"
          style={{ ...styles.searchInput, flex: "1 1 120px", minWidth: 120 }}
          value={searchDt} onChange={e => setSearchDt(e.target.value)} />
        <button style={{ ...styles.searchBtn, flexShrink: 0 }} onClick={handleSearch}>검색</button>
        <button style={{ ...styles.searchBtn, flexShrink: 0, background: "#888" }} onClick={handleReset}>초기화</button>
      </div>

      {/* 리스트 */}
      <div style={styles.card}>
        <div style={styles.tableHeader}>
          {["연번", "병원명", "환자명", "시작일", "종료일", "간병사1", "간병사2", "간병사3"].map(h => (
            <div key={h} style={styles.th}>{h}</div>
          ))}
        </div>
        {loading ? (
          <div style={styles.empty}>⏳ 불러오는 중...</div>
        ) : paginated.length === 0 ? (
          <div style={styles.empty}>간병정보가 없습니다.</div>
        ) : paginated.map((item, i) => (
          <div key={i} style={styles.tableRow}
            onClick={() => loadDetail(item.seq_no)}
            onMouseEnter={e => e.currentTarget.style.background = "#f8faff"}
            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
            <div style={styles.td}>{item.seq_no}</div>
            <div style={styles.td}>{item.hospital_name || "-"}</div>
            <div style={{ ...styles.td, fontWeight: 600 }}>{item.patient_name || "-"}</div>
            <div style={styles.td}>{item.care_start_dt || "-"}</div>
            <div style={styles.td}>{item.care_end_dt   || "-"}</div>
            <div style={styles.td}>{item.carer1_name   || "-"}</div>
            <div style={styles.td}>{item.carer2_name   || "-"}</div>
            <div style={styles.td}>{item.carer3_name   || "-"}</div>
          </div>
        ))}
        {totalPages > 1 && (
          <div style={styles.pagination}>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
              <button key={p}
                style={{ ...styles.pageBtn, ...(p === currentPage ? styles.pageBtnActive : {}) }}
                onClick={() => setCurrentPage(p)}>{p}</button>
            ))}
          </div>
        )}
      </div>

      {isAdmin && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
          <button style={styles.registerBtn}
            onClick={() => { setSelected(null); setIsNew(true); setPage("detail"); }}>
            ＋ 신규등록
          </button>
        </div>
      )}
    </div>
  );
}

// ===================== 스타일 =====================
const styles = {
  wrap        : { background: "#f5f7fa", padding: 24, fontFamily: "'Noto Sans KR', sans-serif" },
  pageHeader  : { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 },
  pageTitle   : { fontSize: 22, fontWeight: 800, color: "#1a1a2e", margin: "0 0 4px" },
  seqBadge    : { background: "#e8f4fd", color: "#1677ff", border: "1px solid #bae0ff", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600 },
  statBadge   : { background: "#e8f4fd", color: "#1677ff", border: "1px solid #bae0ff", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600 },
  filterCard  : { background: "#fff", borderRadius: 12, padding: "14px 16px", marginBottom: 12, display: "flex", gap: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" },
  searchInput : { border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "10px 14px", fontSize: 14, fontFamily: "inherit", outline: "none", background: "#fafafa" },
  searchBtn   : { background: "#1677ff", color: "#fff", border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
  card        : { background: "#fff", borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", overflow: "hidden" },
  tableHeader : { display: "grid", gridTemplateColumns: "0.5fr 1.5fr 1fr 1fr 1fr 1fr 1fr 1fr", padding: "12px 20px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" },
  th          : { fontSize: 12, fontWeight: 700, color: "#888" },
  tableRow    : { display: "grid", gridTemplateColumns: "0.5fr 1.5fr 1fr 1fr 1fr 1fr 1fr 1fr", padding: "14px 20px", borderBottom: "1px solid #f5f5f5", cursor: "pointer", transition: "background 0.15s" },
  td          : { fontSize: 14, color: "#1a1a2e", display: "flex", alignItems: "center" },
  empty       : { textAlign: "center", padding: "60px 0", color: "#bbb", fontSize: 14 },
  pagination  : { display: "flex", justifyContent: "center", gap: 6, padding: "14px 0" },
  pageBtn     : { width: 30, height: 30, borderRadius: 6, border: "1px solid #e0e0e0", background: "#fff", cursor: "pointer", fontSize: 13, color: "#666" },
  pageBtnActive: { background: "#1677ff", color: "#fff", border: "1px solid #1677ff" },
  registerBtn : { background: "linear-gradient(135deg, #1677ff, #4096ff)", color: "#fff", border: "none", borderRadius: 10, padding: "12px 24px", fontSize: 14, fontWeight: 700, cursor: "pointer", boxShadow: "0 4px 12px rgba(22,119,255,0.35)" },
  backBtn     : { background: "none", border: "1px solid #e0e0e0", borderRadius: 8, padding: "8px 14px", fontSize: 13, color: "#666", cursor: "pointer", marginBottom: 12, display: "block" },
  editBtn     : { background: "#fff", border: "1.5px solid #1677ff", color: "#1677ff", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
  deleteBtn   : { background: "#fff2f0", border: "1.5px solid #ff4d4f", color: "#ff4d4f", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
  printBtn    : { background: "#fff", border: "1.5px solid #52c41a", color: "#52c41a", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
};

const detailStyles = {
  grid  : { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  field : { display: "flex", flexDirection: "row", alignItems: "center", gap: 0, background: "#fafafa", borderRadius: 8, border: "1.5px solid #e0e0e0", overflow: "hidden" },
  label : { fontSize: 13, fontWeight: 600, color: "#666", background: "#f0f4ff", padding: "12px 16px", minWidth: 120, whiteSpace: "nowrap", borderRight: "1.5px solid #e0e0e0" },
  input : { border: "none", borderRadius: 0, padding: "12px 16px", fontSize: 14, outline: "none", background: "transparent", color: "#1a1a2e", width: "100%", boxSizing: "border-box" },
};

const ms = {
  overlay  : { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" },
  modal    : { background: "#fff", borderRadius: 16, width: "100%", maxWidth: 460, margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" },
  cancelBtn: { background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#666", cursor: "pointer" },
  saveBtn  : { border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#fff", fontWeight: 700, cursor: "pointer" },
};